import axios from 'axios';

type FindOrgType = {
  requestType:
    | 'count'
    | 'completed'
    | 'queue'
    | 'noMoreShowings'
    | 'unconfigured'
    | 'unassigned'
    | 'duplicates'
    | 'offers'
    | 'exclusives';
  query?: Query;
};

type Query = {
  locations?: string[];
  sortDirection?: number;
  sortBy?: string;
  page: number;
};

const findOrg = async ({ requestType, query }: FindOrgType) => {
  const { data } = await axios.get(`/org/appointments/${requestType}`, {
    params: query,
  });
  return data;
};

export default findOrg;
